import React from "react";
import { Logo } from "./Header";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-32 border-t border-border bg-background">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-12 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div className="lg:col-span-2">
          <Logo />
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">
            {t("landing.heroSubtitle")}
          </p>
        </div>
        <div>
          <div className="font-mono text-xs uppercase text-muted-foreground">Product</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="/#features" className="hover:underline">{t("nav.features")}</a></li>
            <li><a href="/#how" className="hover:underline">{t("nav.how")}</a></li>
            <li><a href="/pricing" className="hover:underline">{t("nav.pricing")}</a></li>
            <li><a href="/#faq" className="hover:underline">{t("nav.faq")}</a></li>
            <li><a href="/contact" className="hover:underline" data-testid="footer-contact">Contact</a></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-xs uppercase text-muted-foreground">Legal</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><a href="/legal/privacy" className="hover:underline" data-testid="footer-privacy">Confidentialité</a></li>
            <li>
              <a href="/legal/terms" className="hover:underline" data-testid="footer-terms">CGU</a>
              <span className="mx-2 text-muted-foreground">·</span>
              <a href="/legal/cgv" className="hover:underline" data-testid="footer-cgv">CGV</a>
            </li>
            <li><a href="/legal/legal-notice" className="hover:underline" data-testid="footer-legal-notice">Mentions légales</a></li>
            <li><a href="/status" className="hover:underline" data-testid="footer-status">Status</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-4 py-6 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <p className="font-mono text-xs text-muted-foreground">
            © {year} SAVEBOX. {t("landing.footerRights")}
          </p>
          <p className="font-mono text-xs text-muted-foreground">
            cloud-to-cloud · incremental · scheduled
          </p>
        </div>
      </div>
    </footer>
  );
}
